import React from 'react';
import { withTranslation } from 'react-i18next';
import { withBrand } from '../../../providers/BrandProvider';
import PaymentJourneyMessage from '../PaymentJourneyMessage/PaymentJourneyMessage';
import BaseSectionTitle from '../../siteBaseSections/baseSectionComponents/BaseSectionTitle/BaseSectionTitle';
import BaseSectionText from '../../siteBaseSections/baseSectionComponents/BaseSectionText/BaseSectionText';
import BaseSectionCTA from '../../siteBaseSections/baseSectionComponents/BaseSectionCTA/BaseSectionCTA';

export function OrderExpiredSection({ t, brand: { secondaryColor } }) {
  return (
    <PaymentJourneyMessage
      header={
        <BaseSectionTitle
          text={t('event.purchase.payment-expired')}
          style={{
            color: secondaryColor,
          }}
        />
      }
      body={
        <BaseSectionText
          text={
            <>
              <p>{t('event.purchase.payment-expired.1')}</p>
              <p>{t('event.purchase.payment-expired.2')}</p>
            </>
          }
          jsx
        />
      }
      footer={<BaseSectionCTA primary={{ type: 'BUY_LINK' }} mode="black" />}
    />
  );
}

export default withTranslation()(withBrand(OrderExpiredSection));
